import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Notifications'));

function LoadableNotifications() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableNotifications;
